import React, { useState, useEffect, useRef } from "react";
import { useStateValue } from "../context/StateProvider";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { ToastContainer, toast } from "react-toastify";
import { SideMenu } from "../components";
import userlogo from "../images/user.png";
import "./index.css";
import LeaveRequest from "../screens/LeaveRequest";
import { actionType } from "../context/reducer";
import CreateEmployee from "../screens/CreateEmployee";
import HoursWorked from "../screens/HoursWorked";
import CreateProject from "../screens/CreateProject";
import AddEmployeeToProject from "../screens/AddEmployeeToProject";
import Blogs from "../screens/Blogs";
import { IoIosCloseCircle } from "react-icons/io";
import { MdEditDocument, MdDelete } from "react-icons/md";
import { messaging } from "./../../firebase.config";
import Signins from "../images/signin.png";

import {
  deleteDocument,
  getAllEmployeeForProject,
  getgeneralNestedItemdualcondition,
  updateItem,
} from "../../utils/firebasefunctions";
import { downloadExcel } from "react-export-table-to-excel";
import moment from "moment";
import { saveAs } from "file-saver";
import emailjs from "emailjs-com";
import {
  setKey,
  setDefaults,
  setLanguage,
  setRegion,
  fromAddress,
  fromLatLng,
  fromPlaceId,
  setLocationType,
  geocode,
  RequestType,
} from "react-geocode";
import { IoCheckmarkCircle } from "react-icons/io5";
import DatePicker from "react-datepicker";
import { RotatingLines } from "react-loader-spinner";
import "react-datepicker/dist/react-datepicker.css";
import ProjectPopUp from "./ProjectPopUp";
import DesignationPopUp from "./DesignationPopUp";
import Slots from "../screens/Slots";
import { deleteDoc, doc } from "firebase/firestore";
import { firestored } from "../../firebase.config";
import Confirmationpopup from "./Confirmationpopup";
import { TbRuler } from "react-icons/tb";
import CreateVehichle from "../screens/CreateVehichle";
import AddSupervisorToVehicle from "../screens/AddSupervisorToVehicle";
import ToDolist from "../screens/ToDolist";
import CreateExpressDelivery from "../screens/CreateExpressDelivery";
import NotificationBell from "./Notifications";
import { getToken } from "firebase/messaging";
import { getAuth, signOut } from "firebase/auth";

const AdminHome = (props) => {
  const header = [
    "Hours Status",
    "Approved By",
    "Emp ID",
    "Name",
    "Project Title",
    "Designation",
    "Hourly Salary",
    "Check In",
    "Lunch In",
    "Lunch Out",
    "Check Out",
    "Total Break Time",
    "Total Time Of Day",
    "Vehicle Checkin Mileage (KM's)",
    "Vehicle Checkout Mileage (KM's)",
    "NORMAL HRS",
    "EVENING HRS",
    "NIGHT HRS",
    "HOURLY SALARY NORMAL",
    "HOURLY SALARY EVENING",
    "HOURLY SALARY NIGHT",
    "TOTAL SALARY",
    "INVOICING AMOUNT WITH A MULTIPLICATOR",
    "Fixed Amount",
    "Supervisor Note",
    "Employee Note",
  ];

  const groupedheader = [
    "Emp ID",
    "Name",
    "Project Title",
    "Designation",
    // "Hourly Salary",
    "Total Hours Worked",
  ];
  const [
    {
      clientemployees,
      clientsupervisors,
      clientprojects,
      selectedtile,
      user,
      employees,
      supervisors,
      clients,
      projects,
      allclients,
      project,
      designation,
      startdate,
      enddate,
    },
    dispatch,
  ] = useStateValue();
  const [designationcolors, setdesignationcolors] = useState([]);
  const [generalemployeecheckindata, setgeneralemployeecheckindata] = useState(
    [],
  );
  const [
    generalgroupedemployeecheckindata,
    setgeneralgroupedemployeecheckindata,
  ] = useState([]);
  const [employeecheckindata, setemployeecheckindata] = useState([]);
  const [employeedata, setemployeedata] = useState();
  const [loading, setloading] = useState(false);
  const [groupby, setgroupby] = useState("Slots");
  const [recorddeletionloader, setrecorddeletionloader] = useState(false);
  const [projectselectionpopup, setprojectselectionpopup] = useState(false);
  const [confirmdeletepopup, setconfirmdeletepopup] = useState(false);
  const [deletionmessage, setdeletionmessage] = useState("");
  const [userpopup, setuserpopup] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [deletiondata, setdeletiondata] = useState("");
  const [designationselectionpopup, setdesignationselectionpopup] =
    useState(false);

  const designationselectionpopupref = useRef(null);
  const userpopupref = useRef(null);

  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userpopupref.current &&
        !userpopupref.current.contains(event.target)
      ) {
        setuserpopup(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userpopupref]);

  useEffect(() => {
    getgeneralhours();
  }, [startdate, enddate, project, groupby]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        designationselectionpopupref.current &&
        !designationselectionpopupref.current.contains(event.target)
      ) {
        setdesignationselectionpopup(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [designationselectionpopupref]);

  const editprofile = () => {
    navigate("/dashboard", {
      state: {
        employeedata: user,
      },
    });
    setuserpopup(false);
  };

  async function requestPermission() {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BBb7l_frsXySelNGhOBb5H1qNI7jOb5qdqpivVz2CPiw3sc9nfg6EW4Ub6oSUPOCbH52Q6TOejfZTExlxHovnCc",
      });

      if (
        user?.NotificationToken != undefined &&
        user?.NotificationToken?.find((item) => item == token) != undefined
      ) {
        let data = [...user.NotificationToken];
        data = data.filter(function (item) {
          return item != token;
        });

        let dataset = {
          NotificationToken: data,
        };

        await updateItem("users", user?.id, dataset)
          .then(async (response) => {
            signout();
          })
          .catch((err) => {
            alert(err);
          });
      } else {
        signout();
      }
    } else if (permission === "denied") {
      //notifications are blocked
      signout();
    }
  }

  const [expandedNote, setExpandedNote] = useState({
    rowIndex: null,
    type: null,
  });

  const toggleExpand = (e, index, type) => {
    e.stopPropagation();
    if (expandedNote.rowIndex === index && expandedNote.type === type) {
      setExpandedNote({ rowIndex: null, type: null });
    } else {
      setExpandedNote({ rowIndex: index, type: type });
    }
  };

  const signout = async () => {
    signOut(auth)
      .then(() => {
        dispatch({
          type: actionType.SET_USER,
          payload: [],
        });
        setuserpopup(!userpopup);
        navigate("/");
      })
      .catch((error) => {
        alert("sign out error");
      });
  };

  const getgeneralhours = async () => {
    // employees
    // designation
    // console.log(JSON.stringify(project))
    setloading(true);
    // setgeneralemployeecheckindata([]);
    // setgeneralgroupedemployeecheckindata([]);
    let data = [];
    if (project == "") {
      let dataset = [];
      for (const key in employees) {
        dataset.push(employees[key].id);
      }

      await getgeneralNestedItemdualcondition(
        "slots",
        dataset,
        "checkindatetime",
        ">=",
        startdate.getTime(),
        "checkindatetime",
        "<=",
        enddate.getTime(),
      )
        .then(async (response) => {
          let responsedata = [...response];

          responsedata = responsedata.sort((a, b) => {
            const aTime = a.starttimetimestamp || 0;
            const bTime = b.starttimetimestamp || 0;
            return bTime - aTime; // descending: latest first
          });

          responsedata = responsedata
            .filter(function (data) {
              return (
                (data?.manualhoursaddedby == "employee" &&
                  data?.hoursapproved == true) ||
                data?.manualhoursaddedby == undefined
              );
            })
            .map(function (data) {
              return data;
            });

          for (const index in responsedata) {
            responsedata[index]["employeedata"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data;
              });
            responsedata[index]["name"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.firstname + " " + data.lastname;
              });
            responsedata[index]["designation"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.projectdesignation;
              });
            responsedata[index]["profilepicture"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.profilepicture;
              });
            responsedata[index]["employeeidd"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.employeeid;
              });
          }
          data = [...data, ...responsedata];
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      let dataset = [];
      for (const key in project.employees) {
        dataset.push(project.employees[key]);
      }

      await getgeneralNestedItemdualcondition(
        "slots",
        dataset,
        "checkindatetime",
        ">=",
        startdate.getTime(),
        "checkindatetime",
        "<=",
        enddate.getTime(),
        "projectid",
        "==",
        project?.id,
      )
        .then(async (response) => {
          let responsedata = [...response];

          responsedata = responsedata.sort((a, b) => {
            const aTime = a.starttimetimestamp || 0;
            const bTime = b.starttimetimestamp || 0;
            return bTime - aTime; // descending: latest first
          });

          responsedata = responsedata
            .filter(function (data) {
              return (
                (data?.manualhoursaddedby == "employee" &&
                  data?.hoursapproved == true) ||
                data?.manualhoursaddedby == undefined
              );
            })
            .map(function (data) {
              return data;
            });

          for (const index in responsedata) {
            responsedata[index]["employeedata"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data;
              });
            responsedata[index]["name"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.firstname + " " + data.lastname;
              });
            responsedata[index]["designation"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.projectdesignation;
              });
            responsedata[index]["profilepicture"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.profilepicture;
              });
            responsedata[index]["employeeidd"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.employeeid;
              });
          }
          data = [...data, ...responsedata];
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    }

    console.log("this is all the data in the world " + JSON.stringify(data));
    setgeneralemployeecheckindata(data);

    if (groupby == "Project") {
      let groupingdata = [...data];
      let newgroupeddata = [];
      for (const key in groupingdata) {
        let projectdesgempindex = newgroupeddata.findIndex((data) => {
          return (
            data.employeeid == groupingdata[key].employeeid &&
            data.projectid == groupingdata[key].projectid &&
            data.projectdesignation == groupingdata[key].projectdesignation
          );
        });
        if (projectdesgempindex != -1) {
          if (newgroupeddata[projectdesgempindex].minutes != undefined) {
            newgroupeddata[projectdesgempindex].minutes =
              newgroupeddata[projectdesgempindex].minutes +
              groupingdata[key].minutes;
          } else {
            newgroupeddata[projectdesgempindex]["minutes"] =
              groupingdata[key].minutes;
          }
        } else {
          newgroupeddata.push({
            employeeid: groupingdata[key].employeeid,
            projectid: groupingdata[key].projectid,
            projectdesignation: groupingdata[key].projectdesignation,
            minutes: groupingdata[key].minutes,
            employeedata: groupingdata[key].employeedata,
            name: groupingdata[key].name,
            profilepicture: groupingdata[key].profilepicture,
            employeeidd: groupingdata[key].employeeidd,
            projectname: clients
              .filter(function (data) {
                return data.id == groupingdata[key].projectid;
              })
              .map(function (data) {
                return data.title;
              }),
            projectprofilepicture: clients
              .filter(function (data) {
                return data.id == groupingdata[key].projectid;
              })
              .map(function (data) {
                return data.logo;
              }),
          });
        }
      }

      //       employeeid
      // projectid
      // projectdesignation
      console.log(
        "this is all the grouped data in the world " +
          JSON.stringify(newgroupeddata),
      );
      setgeneralgroupedemployeecheckindata(newgroupeddata);
    }

    setloading(false);
  };
  const getlocationaddress = (lat, long) => {
    fromLatLng(lat, long)
      .then(({ results }) => {
        alert(results[0].formatted_address);
      })
      .catch(console.error);
  };

  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  function hexToRgba(hex, alpha) {
    // Remove the '#' character if it exists
    hex = hex.replace(/^#/, "");

    // Parse the r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Ensure alpha is between 0 and 1
    alpha = Math.max(0, Math.min(1, alpha));

    // Return the rgba color string
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const getallprojectemployees = async (projectid) => {
    await getAllEmployeeForProject(
      "users",
      "usertype",
      "==",
      "Employee",
      projectid,
    )
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_PROJECTEMPLOYEES,
          payload: response,
        });

        // toast.success("Signed in Successfully")
        // navigate('/home')
      })
      .catch((err) => {
        alert(err);
      });
  };

  const generateAndSaveCSV = (headers, data, name) => {
    // Convert headers and data to CSV format
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...data.map((row) => row.join(","))].join("\n");

    // Convert to Blob
    const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Save the file locally
    saveAs(csvBlob, `${name}.csv`);

    return csvBlob; // Return Blob for further use
  };

  const groupByProjectId = (data) => {
    let sortedprojectdata = [];
    for (const key in data) {
      if (
        sortedprojectdata.find(
          (item) => item.projectid == data[key].projectid,
        ) == undefined
      ) {
        sortedprojectdata.push({
          projectid: data[key].projectid,
          slotsdata: [],
        });
      }
      const projectindex = sortedprojectdata.findIndex(
        (itemdata) => itemdata.projectid === data[key].projectid,
      );
      sortedprojectdata[projectindex]?.slotsdata.push(data[key]);
    }

    return sortedprojectdata; // Convert Map values to an array of arrays
  };

  const bulkDeleteRecords = async (recordIds) => {
    try {
      const deletePromises = recordIds.map(async (id) => {
        const docRef = doc(firestored, "slots", id.toString()); // Replace "yourCollectionName"
        await deleteDoc(docRef);
        console.log(`Deleted record: ${id}`);
      });

      await Promise.all(deletePromises);
      toast.success("All selected records deleted successfully!");
      getgeneralhours();
      setrecorddeletionloader(false);
    } catch (error) {
      console.error("Error deleting records:", error);
      toast.warn("Error deleting records");
      setrecorddeletionloader(false);
    }
  };

  const handleDeleteGeneral = async () => {
    setrecorddeletionloader(true);

    const groupedData = groupByProjectId(generalemployeecheckindata);
    let attachmentdata = [];

    for (const dataindex in groupedData) {
      let newdata = [];
      let newgeneralemployeecheckindata = [...groupedData[dataindex].slotsdata];
      let data;
      newgeneralemployeecheckindata.map((val, id) => {
        if (val?.checkintime != undefined && val?.checkouttime != undefined) {
          data = clients.find((project) => project.id === val?.projectid);
          const hoursWorked =
            data?.eveningPercentage ||
            data?.normalPercentage ||
            data?.nightPercentage
              ? calculateShiftHours(
                  shiftmaker(data),
                  val?.checkintime,
                  val?.checkouttime,
                )
              : {};
          newgeneralemployeecheckindata[id]["hoursWorked"] = hoursWorked;
          const normalAmount = val?.priceperhour
            ? calculateSalary(
                hoursWorked?.Normal?.hours,
                hoursWorked?.Normal?.minutes,
                val?.priceperhour,
                shifts[0]?.percentage,
              )
            : 0;
          const eveningAmount = val?.priceperhour
            ? calculateSalary(
                hoursWorked?.Evening?.hours,
                hoursWorked?.Evening?.minutes,
                val?.priceperhour,
                shifts[1]?.percentage,
              )
            : 0;
          const nightAmount = val?.priceperhour
            ? calculateSalary(
                hoursWorked?.Night?.hours,
                hoursWorked?.Night?.minutes,
                val?.priceperhour,
                shifts[2]?.percentage,
              )
            : 0;
          const totalSalary =
            (normalAmount > 0 ? normalAmount : 0) +
            (eveningAmount > 0 ? eveningAmount : 0) +
            (nightAmount > 0 ? nightAmount : 0);
          const mutiplicatorPrice = data?.multiplicatorPercentageStatus
            ? totalSalary * data.multiplicatorPercentage
            : 0;
          const totalHours = val?.minutes
            ? parseInt(val?.minutes / 60) +
              " hrs " +
              parseInt(val?.minutes % 60) +
              " mins"
            : 0 + " mins";
          const fixedPrice =
            data?.fixedprice > 0
              ? calculateFixedAmount(
                  val?.minutes ? parseInt(val?.minutes / 60) : 0,
                  val?.minutes ? parseInt(val?.minutes % 60) : 0,
                  data.fixedprice,
                )
              : 0;
          designation.find((data) => data.selected == true)
            ? designation.find((data) => data.selected == true) == undefined ||
              (designation.find(
                (data) =>
                  data.selected == true &&
                  val.projectdesignation == data.designation,
              ) != undefined &&
                newdata.push([
                  val?.hoursapproved == true
                    ? "Approved"
                    : val?.hoursapproved == false
                      ? "Rejected"
                      : "Pending",
                  val.employeeidd,
                  val.name ? val.name : "NA",
                  project.title ? project.title : data ? data.title : "NA",
                  val.projectdesignation ? val.projectdesignation : "NA",
                  val?.priceperhour,
                  val.checkindatetime
                    ? moment(val.checkindatetime).format(
                        "YYYY-MM-DD hh:mm:ss a",
                      )
                    : "NA",
                  val.lunchstarttime && val.lunchallowed
                    ? `${val.sheduleddate + " " + val.lunchstarttime}`
                    : "NA",
                  val.lunchendtime && val.lunchallowed
                    ? `${val.sheduleddate + " " + val.lunchendtime}`
                    : "NA",
                  val.checkoutdatetime
                    ? moment(val.checkoutdatetime).format(
                        "YYYY-MM-DD hh:mm:ss a",
                      )
                    : "NA",
                  val.lunchstarttime && val.lunchendtime && val.lunchallowed
                    ? timeDifference(
                        val.sheduleddate + " " + val.lunchstarttime,
                        val.sheduleddate + " " + val.lunchendtime,
                      )
                    : "NA",
                  totalHours,
                  hoursWorked?.Normal
                    ? hoursWorked.Normal.hours +
                      " hrs " +
                      hoursWorked.Normal.minutes +
                      " mins "
                    : "NA",
                  hoursWorked?.Evening
                    ? hoursWorked.Evening.hours +
                      " hrs " +
                      hoursWorked.Evening.minutes +
                      " mins "
                    : "NA",
                  hoursWorked?.Night
                    ? hoursWorked.Night.hours +
                      " hrs " +
                      hoursWorked.Night.minutes +
                      " mins "
                    : "NA",
                  normalAmount.toFixed(2),
                  eveningAmount.toFixed(2),
                  nightAmount.toFixed(2),
                  totalSalary ? totalSalary.toFixed(2) : 0,
                  mutiplicatorPrice.toFixed(2),
                  fixedPrice.toFixed(2),
                ]))
            : newdata.push([
                val?.hoursapproved == true
                  ? "Approved"
                  : val?.hoursapproved == false
                    ? "Rejected"
                    : "Pending",
                val.employeeidd,
                val.name ? val.name : "NA",
                project.title ? project.title : data ? data.title : "NA",
                val.projectdesignation ? val.projectdesignation : "NA",
                val?.priceperhour,
                val.checkindatetime
                  ? moment(val.checkindatetime).format("YYYY-MM-DD hh:mm:ss a")
                  : "NA",
                val.lunchstarttime && val.lunchallowed
                  ? `${val.sheduleddate + " " + val.lunchstarttime}`
                  : "NA",
                val.lunchendtime && val.lunchallowed
                  ? `${val.sheduleddate + " " + val.lunchendtime}`
                  : "NA",
                val.checkoutdatetime
                  ? moment(val.checkoutdatetime).format("YYYY-MM-DD hh:mm:ss a")
                  : "NA",
                val.lunchstarttime && val.lunchendtime && val.lunchallowed
                  ? timeDifference(
                      val.sheduleddate + " " + val.lunchstarttime,
                      val.sheduleddate + " " + val.lunchendtime,
                    )
                  : "NA",
                totalHours,
                hoursWorked?.Normal
                  ? hoursWorked.Normal.hours +
                    " hrs " +
                    hoursWorked.Normal.minutes +
                    " mins "
                  : "NA",
                hoursWorked?.Evening
                  ? hoursWorked.Evening.hours +
                    " hrs " +
                    hoursWorked.Evening.minutes +
                    " mins "
                  : "NA",
                hoursWorked?.Night
                  ? hoursWorked.Night.hours +
                    " hrs " +
                    hoursWorked.Night.minutes +
                    " mins "
                  : "NA",
                normalAmount.toFixed(2),
                eveningAmount.toFixed(2),
                nightAmount.toFixed(2),
                totalSalary ? totalSalary.toFixed(2) : 0,
                mutiplicatorPrice.toFixed(2),
                fixedPrice.toFixed(2),
              ]);
        }
      });

      const totalHoursworkedforallemployees =
        newgeneralemployeecheckindata.reduce(
          (sum, row) => sum + (row?.minutes ? row.minutes : 0),
          0,
        );
      const totalnormalHoursworkedforallemployees =
        newgeneralemployeecheckindata.reduce(
          (sum, row) =>
            sum +
            (row?.hoursWorked?.Normal
              ? row.hoursWorked?.Normal?.totalminutes
              : 0),
          0,
        );
      const totaleveningHoursworkedforallemployees =
        newgeneralemployeecheckindata.reduce(
          (sum, row) =>
            sum +
            (row?.hoursWorked?.Evening
              ? row.hoursWorked?.Evening?.totalminutes
              : 0),
          0,
        );
      const totalnightHoursworkedforallemployees =
        newgeneralemployeecheckindata.reduce(
          (sum, row) =>
            sum +
            (row?.hoursWorked?.Night
              ? row.hoursWorked?.Night?.totalminutes
              : 0),
          0,
        );

      newdata.push([
        "",
        "Total",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        parseInt(totalHoursworkedforallemployees / 60) +
          " hrs " +
          parseInt(totalHoursworkedforallemployees % 60) +
          " mins",
        parseInt(totalnormalHoursworkedforallemployees / 60) +
          " hrs " +
          parseInt(totalnormalHoursworkedforallemployees % 60) +
          " mins",
        parseInt(totaleveningHoursworkedforallemployees / 60) +
          " hrs " +
          parseInt(totaleveningHoursworkedforallemployees % 60) +
          " mins",
        parseInt(totalnightHoursworkedforallemployees / 60) +
          " hrs " +
          parseInt(totalnightHoursworkedforallemployees % 60) +
          " mins",
        "",
        "",
        "",
        "",
        "",
        "",
      ]);
      // console.log(newdata);

      // downloadExcel({
      //   fileName: data.title.toString(),
      //   sheet: data.title,
      //   tablePayload: {
      //     header,
      //     body: newdata,
      //   },
      // });

      attachmentdata.push({
        name: data.title.toString(),
        dataarray: newdata,
      });

      //  const csvBlob = generateAndSaveCSV(header, newdata); // Generate & Save CSV file
      //  // Convert Blob to File
      //  const file = new File([csvBlob], "GeneralSlots.csv", { type: "text/csv" });
    }

    const formData = new FormData();
    formData.append("email", user.email);
    formData.append("from_name", "Deleted Slots");
    formData.append(
      "message",
      `${moment(startdate).format("YYYY-MM-DD")} - ${moment(enddate).format(
        "YYYY-MM-DD",
      )}`,
    );
    formData.append("service_id", "service_5z77uee");
    formData.append("template_id", "template_jw6dv7e");
    formData.append("user_id", "pUoX1kN2nzw7N8UsM");

    // formData.append("attachment", file);

    attachmentdata.forEach((file, index) => {
      const csvBlob = generateAndSaveCSV(
        header,
        file.dataarray,
        index.toString(),
      ); // Generate & Save CSV file
      // Convert Blob to File
      const filedata = new File([csvBlob], `${file.name}.csv`, {
        type: "text/csv",
      });
      formData.append(`attachment${index + 1}`, filedata);
      // console.log("filedata " + index + "  " + JSON.stringify(file.dataarray))
      // console.log("file " + index + "  " + JSON.stringify(filedata))
    });

    try {
      const response = await fetch(
        "https://api.emailjs.com/api/v1.0/email/send-form",
        {
          method: "POST",
          body: formData,
        },
      );

      if (response.ok) {
        let recorids = [];
        console.log("Email sent successfully!");
        toast.success("Deleted records mailed to Admin!");
        for (const key in groupedData) {
          for (const innerkey in groupedData[key].slotsdata) {
            recorids.push(
              groupedData[key].slotsdata[innerkey].schedulecreationdate,
            );
            // console.log( JSON.stringify(groupedData[key].slotsdata[innerkey].schedulecreationdate))
          }
        }
        bulkDeleteRecords(recorids);
      } else {
        console.error("Failed to send email:", response);
        setrecorddeletionloader(false);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setrecorddeletionloader(false);
    }
    // console.log("All attachements " + JSON.stringify(attachmentdata))
    // const formData = new FormData();
    // formData.append("email", "humzasamiullah@gmail.com");
    // formData.append("message", "day 2 2.");
    // formData.append("service_id", "service_5z77uee");
    // formData.append("template_id", "template_jw6dv7e");
    // formData.append("user_id", "pUoX1kN2nzw7N8UsM");
    // formData.append(`Attachment1`, filedata);
    // formData.append("Attachment", file); // Attach the Excel file

    // attachmentdata.forEach((file, index) => {
    //   const csvBlob = generateAndSaveCSV(header, file.dataarray); // Generate & Save CSV file
    //   // Convert Blob to File
    //   const filedata = new File([csvBlob], `${index.toString()}.csv`, { type: "text/csv" });
    //   formData.append(`Attachment${index + 1}`, filedata);
    //   console.log("filedata " + index + "  " + JSON.stringify(file.dataarray))
    //   console.log("file " + index + "  " + JSON.stringify(filedata))
    // });
  };

  const handleDownloadExcelGeneral = () => {
    let newdata = [];
    let newgeneralemployeecheckindata = [...generalemployeecheckindata];
    newgeneralemployeecheckindata.reverse().map((val, id) => {
      if (
        val?.checkintime != undefined &&
        val?.checkouttime != undefined &&
        ((val?.manualhoursaddedby == "employee" &&
          val?.hoursapproved == true) ||
          val?.manualhoursaddedby == undefined)
      ) {
        const data = clients.find((project) => project.id === val?.projectid);
        const hoursWorked =
          data?.eveningPercentage ||
          data?.normalPercentage ||
          data?.nightPercentage
            ? calculateShiftHours(
                shiftmaker(data),
                val?.checkintime,
                val?.checkouttime,
              )
            : {};
        newgeneralemployeecheckindata[id]["hoursWorked"] = hoursWorked;
        const normalAmount = val?.priceperhour
          ? calculateSalary(
              hoursWorked?.Normal?.hours,
              hoursWorked?.Normal?.minutes,
              val?.priceperhour,
              shifts[0]?.percentage,
            )
          : 0;
        const eveningAmount = val?.priceperhour
          ? calculateSalary(
              hoursWorked?.Evening?.hours,
              hoursWorked?.Evening?.minutes,
              val?.priceperhour,
              shifts[1]?.percentage,
            )
          : 0;
        const nightAmount = val?.priceperhour
          ? calculateSalary(
              hoursWorked?.Night?.hours,
              hoursWorked?.Night?.minutes,
              val?.priceperhour,
              shifts[2]?.percentage,
            )
          : 0;
        const totalSalary =
          (normalAmount > 0 ? normalAmount : 0) +
          (eveningAmount > 0 ? eveningAmount : 0) +
          (nightAmount > 0 ? nightAmount : 0);
        const mutiplicatorPrice = data?.multiplicatorPercentageStatus
          ? totalSalary * data.multiplicatorPercentage
          : 0;
        const totalHours = val?.minutes
          ? parseInt(val?.minutes / 60) +
            " hrs " +
            parseInt(val?.minutes % 60) +
            " mins"
          : 0 + " mins";
        const supervisornotes = val?.supervisornotes
          ? val?.supervisornotes
          : "";
        const employeenotes = val?.employeenotes ? val?.employeenotes : "";

        const fixedPrice =
          data?.fixedprice > 0
            ? calculateFixedAmount(
                val?.minutes ? parseInt(val?.minutes / 60) : 0,
                val?.minutes ? parseInt(val?.minutes % 60) : 0,
                data.fixedprice,
              )
            : 0;
        designation.find((data) => data.selected == true)
          ? designation.find((data) => data.selected == true) == undefined ||
            (designation.find(
              (data) =>
                data.selected == true &&
                val.projectdesignation == data.designation,
            ) != undefined &&
              newdata.push([
                val?.hoursapproved == true
                  ? "Approved"
                  : val?.hoursapproved == false
                    ? "Rejected"
                    : "Pending",
                val?.approvalstatusupdatedby
                  ? val?.approvalstatusupdatedby
                  : "NA",
                val.employeeidd,
                val.name ? val.name : "NA",
                project.title ? project.title : data ? data.title : "NA",
                val.projectdesignation ? val.projectdesignation : "NA",
                val?.priceperhour,
                val.checkindatetime
                  ? moment(val.checkindatetime).format("YYYY-MM-DD hh:mm:ss a")
                  : "NA",
                val.lunchstarttime && val.lunchallowed
                  ? `${val.sheduleddate + " " + val.lunchstarttime}`
                  : "NA",
                val.lunchendtime && val.lunchallowed
                  ? `${val.sheduleddate + " " + val.lunchendtime}`
                  : "NA",
                val.checkoutdatetime
                  ? moment(val.checkoutdatetime).format("YYYY-MM-DD hh:mm:ss a")
                  : "NA",
                val.lunchstarttime && val.lunchendtime && val.lunchallowed
                  ? timeDifference(
                      val.sheduleddate + " " + val.lunchstarttime,
                      val.sheduleddate + " " + val.lunchendtime,
                    )
                  : "NA",
                totalHours,
                val?.vehiclecheckinkms ? val.vehiclecheckinkms : "N/A",
                val?.vehiclecheckoutkms ? val.vehiclecheckoutkms : "N/A",
                hoursWorked?.Normal
                  ? hoursWorked.Normal.hours +
                    " hrs " +
                    hoursWorked.Normal.minutes +
                    " mins "
                  : "NA",
                hoursWorked?.Evening
                  ? hoursWorked.Evening.hours +
                    " hrs " +
                    hoursWorked.Evening.minutes +
                    " mins "
                  : "NA",
                hoursWorked?.Night
                  ? hoursWorked.Night.hours +
                    " hrs " +
                    hoursWorked.Night.minutes +
                    " mins "
                  : "NA",
                normalAmount.toFixed(2),
                eveningAmount.toFixed(2),
                nightAmount.toFixed(2),
                totalSalary ? totalSalary.toFixed(2) : 0,
                mutiplicatorPrice.toFixed(2),
                fixedPrice.toFixed(2),
                supervisornotes,
                employeenotes,
              ]))
          : newdata.push([
              val?.hoursapproved == true
                ? "Approved"
                : val?.hoursapproved == false
                  ? "Rejected"
                  : "Pending",
              val?.approvalstatusupdatedby
                ? val?.approvalstatusupdatedby
                : "NA",
              val.employeeidd,
              val.name ? val.name : "NA",
              project.title ? project.title : data ? data.title : "NA",
              val.projectdesignation ? val.projectdesignation : "NA",
              val?.priceperhour,
              val.checkindatetime
                ? moment(val.checkindatetime).format("YYYY-MM-DD hh:mm:ss a")
                : "NA",
              val.lunchstarttime && val.lunchallowed
                ? `${val.sheduleddate + " " + val.lunchstarttime}`
                : "NA",
              val.lunchendtime && val.lunchallowed
                ? `${val.sheduleddate + " " + val.lunchendtime}`
                : "NA",
              val.checkoutdatetime
                ? moment(val.checkoutdatetime).format("YYYY-MM-DD hh:mm:ss a")
                : "NA",
              val.lunchstarttime && val.lunchendtime && val.lunchallowed
                ? timeDifference(
                    val.sheduleddate + " " + val.lunchstarttime,
                    val.sheduleddate + " " + val.lunchendtime,
                  )
                : "NA",
              totalHours,
              val?.vehiclecheckinkms ? val.vehiclecheckinkms : "N/A",
              val?.vehiclecheckoutkms ? val.vehiclecheckoutkms : "N/A",
              hoursWorked?.Normal
                ? hoursWorked.Normal.hours +
                  " hrs " +
                  hoursWorked.Normal.minutes +
                  " mins "
                : "NA",
              hoursWorked?.Evening
                ? hoursWorked.Evening.hours +
                  " hrs " +
                  hoursWorked.Evening.minutes +
                  " mins "
                : "NA",
              hoursWorked?.Night
                ? hoursWorked.Night.hours +
                  " hrs " +
                  hoursWorked.Night.minutes +
                  " mins "
                : "NA",
              normalAmount.toFixed(2),
              eveningAmount.toFixed(2),
              nightAmount.toFixed(2),
              totalSalary ? totalSalary.toFixed(2) : 0,
              mutiplicatorPrice.toFixed(2),
              fixedPrice.toFixed(2),
              supervisornotes,
              employeenotes,
            ]);
      }
    });

    const totalHoursworkedforallemployees =
      newgeneralemployeecheckindata.reduce(
        (sum, row) => sum + (row?.minutes ? row.minutes : 0),
        0,
      );
    const totalnormalHoursworkedforallemployees =
      newgeneralemployeecheckindata.reduce(
        (sum, row) =>
          sum +
          (row?.hoursWorked?.Normal
            ? row.hoursWorked?.Normal?.totalminutes
            : 0),
        0,
      );
    const totaleveningHoursworkedforallemployees =
      newgeneralemployeecheckindata.reduce(
        (sum, row) =>
          sum +
          (row?.hoursWorked?.Evening
            ? row.hoursWorked?.Evening?.totalminutes
            : 0),
        0,
      );
    const totalnightHoursworkedforallemployees =
      newgeneralemployeecheckindata.reduce(
        (sum, row) =>
          sum +
          (row?.hoursWorked?.Night ? row.hoursWorked?.Night?.totalminutes : 0),
        0,
      );

    newdata.push([
      "",
      "",
      "Total",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      parseInt(totalHoursworkedforallemployees / 60) +
        " hrs " +
        parseInt(totalHoursworkedforallemployees % 60) +
        " mins",
      "",
      "",
      parseInt(totalnormalHoursworkedforallemployees / 60) +
        " hrs " +
        parseInt(totalnormalHoursworkedforallemployees % 60) +
        " mins",
      parseInt(totaleveningHoursworkedforallemployees / 60) +
        " hrs " +
        parseInt(totaleveningHoursworkedforallemployees % 60) +
        " mins",
      parseInt(totalnightHoursworkedforallemployees / 60) +
        " hrs " +
        parseInt(totalnightHoursworkedforallemployees % 60) +
        " mins",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ]);
    // console.log(newdata);

    downloadExcel({
      fileName: "General Sheet",
      sheet: "General-Sheet",
      tablePayload: {
        header,
        body: newdata,
      },
    });
  };

  const handleGroupedDownloadExcelGeneral = () => {
    let newdata = [];
    let newgeneralemployeecheckindata = [...generalgroupedemployeecheckindata];

    newgeneralemployeecheckindata?.map((val, id) => {
      console.log(val?.minutes);
      const data = clients.find((project) => project.id === val?.projectid);
      const totalHours = val?.minutes
        ? parseInt(val?.minutes / 60) +
          " hrs " +
          parseInt(val?.minutes % 60) +
          " mins"
        : 0 + " mins";

      designation.find((data) => data.selected == true)
        ? designation.find((data) => data.selected == true) == undefined ||
          (designation.find(
            (data) =>
              data.selected == true &&
              val.projectdesignation == data.designation,
          ) != undefined &&
            newdata.push([
              val.employeeidd,
              val.name ? val.name : "NA",
              project.title ? project.title : data ? data.title : "NA",
              val.projectdesignation ? val.projectdesignation : "NA",
              // val?.priceperhour,
              totalHours,
            ]))
        : newdata.push([
            val.employeeidd,
            val.name ? val.name : "NA",
            project.title ? project.title : data ? data.title : "NA",
            val.projectdesignation ? val.projectdesignation : "NA",
            // val?.priceperhour,
            totalHours,
          ]);
    });

    downloadExcel({
      fileName: "General Grouped Sheet",
      sheet: "General-Grouped-Sheet",
      tablePayload: {
        header: groupedheader,
        body: newdata,
      },
    });
    // downloadExcel({
    //   fileName: "General Sheet",
    //   sheet: "General-Sheet",
    //   tablePayload: {
    //     header,
    //     body: newdata,
    //   },
    // });

    console.log("grouped stats " + JSON.stringify(newdata));
  };
  const handleDownloadExcelEmployeeData = () => {
    let newdata = [];
    employeecheckindata.map((val, id) => {
      const data = clients.find((project) => project.id === val?.projectid);
      const hoursWorked =
        data?.eveningPercentage ||
        data?.normalPercentage ||
        data?.nightPercentage
          ? calculateShiftHours(
              shiftmaker(data),
              val?.checkintime,
              val?.checkouttime,
            )
          : {};
      const normalAmount = val?.priceperhour
        ? calculateSalary(
            hoursWorked?.Normal?.hours,
            hoursWorked?.Normal?.minutes,
            val?.priceperhour,
            shifts[0]?.percentage,
          )
        : 0;
      const eveningAmount = val?.priceperhour
        ? calculateSalary(
            hoursWorked?.Evening?.hours,
            hoursWorked?.Evening?.minutes,
            val?.priceperhour,
            shifts[1]?.percentage,
          )
        : 0;
      const nightAmount = val?.priceperhour
        ? calculateSalary(
            hoursWorked?.Night?.hours,
            hoursWorked?.Night?.minutes,
            val?.priceperhour,
            shifts[2]?.percentage,
          )
        : 0;
      const totalSalary =
        (normalAmount > 0 ? normalAmount : 0) +
        (eveningAmount > 0 ? eveningAmount : 0) +
        (nightAmount > 0 ? nightAmount : 0);
      const mutiplicatorPrice = data?.multiplicatorPercentageStatus
        ? totalSalary * data.multiplicatorPercentage
        : 0;
      const totalHours = val?.minutes
        ? parseInt(val?.minutes / 60) +
          " hrs " +
          parseInt(val?.minutes % 60) +
          " mins"
        : 0 + " mins";
      const fixedPrice =
        data?.fixedprice > 0
          ? calculateFixedAmount(
              val?.minutes ? parseInt(val?.minutes / 60) : 0,
              val?.minutes ? parseInt(val?.minutes % 60) : 0,
              data.fixedprice,
            )
          : 0;
      newdata.push([
        val.employeeid,
        employeedata?.firstname
          ? employeedata?.firstname + " " + employeedata?.lastname
          : "NA",
        project.title ? project.title : data ? data.title : "NA",
        val?.projectdesignation ? val?.projectdesignation : "NA",
        val.checkindatetime
          ? moment(val.checkindatetime).format("YYYY-MM-DD hh:mm:ss a")
          : "NA",
        val.lunchstarttime && val.lunchallowed
          ? `${val.sheduleddate + " " + val.lunchstarttime}`
          : "NA",
        val.lunchendtime && val.lunchallowed
          ? `${val.sheduleddate + " " + val.lunchendtime}`
          : "NA",
        val.checkoutdatetime
          ? moment(val.checkoutdatetime).format("YYYY-MM-DD hh:mm:ss a")
          : "NA",
        val.lunchstarttime && val.lunchendtime && val.lunchallowed
          ? timeDifference(
              val.sheduleddate + " " + val.lunchstarttime,
              val.sheduleddate + " " + val.lunchendtime,
            )
          : "NA",
        totalHours,
        hoursWorked?.Normal
          ? hoursWorked.Normal.hours +
            " hrs " +
            hoursWorked.Normal.minutes +
            " mins "
          : "NA",
        hoursWorked?.Evening
          ? hoursWorked.Evening.hours +
            " hrs " +
            hoursWorked.Evening.minutes +
            " mins "
          : "NA",
        hoursWorked?.Night
          ? hoursWorked.Night.hours +
            " hrs " +
            hoursWorked.Night.minutes +
            " mins "
          : "NA",
        normalAmount.toFixed(2),
        eveningAmount.toFixed(2),
        nightAmount.toFixed(2),
        totalSalary ? totalSalary.toFixed(2) : 0,
        mutiplicatorPrice.toFixed(2),
        fixedPrice.toFixed(2),
      ]);
    });
    // console.log(newdata);
    downloadExcel({
      fileName: `${
        employeedata?.firstname
          ? employeedata?.firstname + " " + employeedata?.lastname
          : "Employee Sheet"
      }`,
      sheet: "Employee-Sheet",
      tablePayload: {
        header,
        body: newdata,
      },
    });
  };
  // Define the shifts with their start and end times
  const shifts = [];
  function shiftmaker(data) {
    console.log(data);
    if (data?.normalstarttime && data?.normalstarttime) {
      shifts.push({
        name: "Normal",
        start: data?.normalstarttime,
        end: data?.normalendtime,
        percentage: data?.normalPercentage,
      });
    }
    if (data?.eveningstarttime && data?.eveningstarttime) {
      shifts.push({
        name: "Evening",
        start: data?.eveningstarttime,
        end: data?.eveningendtime,
        percentage: data?.eveningPercentage,
      });
    }
    if (data?.nightstarttime && data?.nightstarttime) {
      shifts.push({
        name: "Night",
        start: data?.nightstarttime,
        end: data?.nightendtime,
        percentage: data?.nightPercentage,
      });
    }

    return shifts;
  }

  // Convert time string to Date object for a given date
  // Convert time string to Date object for a given date
  function parseTime(timeStr, baseDate) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate(),
      hours,
      minutes,
    );
  }

  // Calculate hours worked within a time range in hours and minutes
  function calculateOverlap(start1, end1, start2, end2) {
    const start = Math.max(start1.getTime(), start2.getTime());
    const end = Math.min(end1.getTime(), end2.getTime());

    if (start >= end) return { hours: 0, minutes: 0 }; // No overlap

    const overlapMillis = end - start;
    const hours = Math.floor(overlapMillis / (1000 * 60 * 60));
    const minutes = Math.floor(
      (overlapMillis % (1000 * 60 * 60)) / (1000 * 60),
    );
    return { hours, minutes };
  }

  // Calculate hours worked in each shift and return in hours and minutes
  function calculateShiftHours(shifts, workStartTime, workEndTime) {
    let shiftHours = {};

    const baseDate = new Date(); // Use current date as base

    const workStart = parseTime(workStartTime, baseDate);
    const workEnd = parseTime(workEndTime, baseDate);

    shifts.forEach((shift) => {
      const shiftStart = parseTime(shift.start, baseDate);
      const shiftEnd = parseTime(shift.end, baseDate);

      if (shift.start > shift.end) {
        // Shift spans overnight
        const shiftEndMidnight = new Date(baseDate);
        shiftEndMidnight.setDate(shiftEndMidnight.getDate() + 1);
        shiftEndMidnight.setHours(shiftEnd.getHours());
        shiftEndMidnight.setMinutes(shiftEnd.getMinutes());

        const overlap1 = calculateOverlap(
          workStart,
          workEnd,
          shiftStart,
          shiftEndMidnight,
        );
        const overlap2 = calculateOverlap(
          workStart,
          workEnd,
          new Date(baseDate),
          shiftEnd,
        );

        shiftHours[shift.name] = {
          hours: overlap1.hours + overlap2.hours,
          minutes: overlap1.minutes + overlap2.minutes,
        };
      } else {
        // Shift within a single day
        const overlap = calculateOverlap(
          workStart,
          workEnd,
          shiftStart,
          shiftEnd,
        );
        shiftHours[shift.name] = overlap;
      }
    });

    // Convert minutes to hours if greater than 60
    for (const shift in shiftHours) {
      const shiftTime = shiftHours[shift];
      if (shiftTime.minutes >= 60) {
        shiftTime.hours += Math.floor(shiftTime.minutes / 60);
        shiftTime.minutes = shiftTime.minutes % 60;
      }
    }

    shiftHours.Normal["totalminutes"] =
      shiftHours?.Normal?.hours * 60 + shiftHours?.Normal?.minutes;
    shiftHours.Evening["totalminutes"] =
      shiftHours?.Evening?.hours * 60 + shiftHours?.Evening?.minutes;
    shiftHours.Night["totalminutes"] =
      shiftHours?.Night?.hours * 60 + shiftHours?.Night?.minutes;

    return shiftHours;
  }
  function calculateSalary(
    hoursWorked,
    minutesWorked,
    perHourRate,
    percentage,
  ) {
    // console.log(hoursWorked, minutesWorked, perHourRate, percentage);
    // Convert total hours and minutes into total hours
    const totalHours = hoursWorked + minutesWorked / 60;

    // Apply percentage adjustment
    const adjustmentAmount = perHourRate * (percentage / 100);
    // Calculate base salary

    // const baseSalary = totalHours * perHourRate;
    const finalSalary = totalHours * adjustmentAmount;
    // console.log(totalHours, adjustmentAmount);
    return finalSalary ? finalSalary : 0;
  }
  function calculateFixedAmount(hours, minutes, perHourRate) {
    // Convert minutes to hours
    const minutesInHours = minutes / 60;

    // Total hours including minutes
    const totalHours = hours + minutesInHours;
    // Calculate total amount
    const totalAmount = totalHours * perHourRate;

    return totalAmount ? totalAmount : 0;
  }
  function timeDifference(date1, date2) {
    const startTime = new Date(date1);
    const endTime = new Date(date2);
    const differenceInMs = endTime - startTime;
    const totalMinutes = Math.floor(differenceInMs / (1000 * 60));

    // Convert total minutes to hours and minutes
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours} hrs ${minutes} mins`;

    // Helper function to convert time string (hh:mm) to minutes since midnight
    // function timeToMinutes(time) {
    //   const [hours, minutes] = time.split(':').map(Number);
    //   return hours * 60 + minutes;
    // }

    // // Convert times to minutes
    // const startMinutes = timeToMinutes(startTime);
    // const endMinutes = timeToMinutes(endTime);

    // // Calculate the difference in minutes
    // let differenceInMinutes = endMinutes - startMinutes;

    // // If the difference is negative, it means the end time is on the next day
    // if (differenceInMinutes < 0) {
    //   differenceInMinutes += 24 * 60; // Add 24 hours worth of minutes
    // }

    // // Convert difference to hours and minutes
    // const hours = Math.floor(differenceInMinutes / 60);
    // const minutes = differenceInMinutes % 60;

    // return `${hours + ' hrs ' + minutes + ' mins'}`;
  }

  async function deletesinglerecord() {
    await deleteDocument("slots", deletiondata.schedulecreationdate)
      .then(async (response) => {
        if (response == true) {
          setdeletiondata("");
          getgeneralhours();
        } else {
          toast.error(
            "Your slot can not be deleted at the moment. Please try again later!",
          );
        }
      })
      .catch((err) => {
        toast.error(
          "Your slot can not be deleted at the moment. Please try again later!",
        );
        alert(err);
      });
  }
  function Dashboard() {
    return (
      <div className="w-full mt-[60px] md:mt-[0px] ">
        <div className="hidden lg:flex justify-end">
          <NotificationBell />
          <div className="ml-[10px] flex items-center">
            <div
              onClick={() => {
                setuserpopup(!userpopup);
              }}
            >
              <img
                loading="lazy"
                src={
                  user?.profilepicture
                    ? user?.profilepicture
                    : user?.logo
                      ? user?.logo
                      : userlogo
                }
                className="w-[40px] h-[40px] object-cover rounded-full cursor-pointer"
              />
            </div>
          </div>
        </div>
        {user?.usertype == "SuperAdmin" && (
          <>
            <p className="text-white text-[22px] PoppinsRegular ">Client's</p>

            <div className=" overflow-x-auto    mt-5  bg-cardOverlay rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%]">
              <table className="min-w-full   bg-themelightblack text-sm">
                <thead className="ltr:text-left rtl:text-right">
                  <tr>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white"></th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Name
                    </th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Projects
                    </th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Supervisors
                    </th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Employees
                    </th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Email
                    </th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Phone Number
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-white/20 text-center">
                  {allclients &&
                    allclients.map((item, index) => (
                      <tr
                        key={index.toString()}
                        className="hover:bg-[#0989B826]/10 cursor-pointer"
                        onClick={() => {}}
                      >
                        <td className="whitespace-nowrap px-4 py-2 flex justify-center  PoppinsRegular text-white">
                          <img
                            loading="lazy"
                            src={
                              item.profilepicture != ""
                                ? item.profilepicture
                                : userlogo
                            }
                            className="w-[30px] h-[30px] lg:w-[40px] lg:h-[40px] rounded-full"
                          />
                        </td>
                        <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
                          {item.firstname} {item.lastname}
                        </td>
                        <td className="whitespace-nowrap px-16 py-2 PoppinsRegular  text-white">
                          {clients?.filter(function (data) {
                            return data.createdby == item.id;
                          })?.length
                            ? clients?.filter(function (data) {
                                return data.createdby == item.id;
                              })?.length
                            : 0}
                        </td>
                        <td className="whitespace-nowrap px-16 py-2 PoppinsRegular  text-white">
                          {supervisors?.filter(function (data) {
                            return data.createdby == item.id;
                          })?.length
                            ? supervisors?.filter(function (data) {
                                return data.createdby == item.id;
                              })?.length
                            : 0}
                        </td>
                        <td className="whitespace-nowrap px-16 py-2 PoppinsRegular  text-white">
                          {employees?.filter(function (data) {
                            return (
                              data.createdby == item.id &&
                              data.usertype == "Employee"
                            );
                          })?.length
                            ? employees?.filter(function (data) {
                                return (
                                  data.createdby == item.id &&
                                  data.usertype == "Employee"
                                );
                              })?.length
                            : 0}
                        </td>
                        <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
                          {item.email}
                        </td>
                        <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
                          {item.phonenumber}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {user?.usertype == "Admin" ||
        (user?.usertype == "Supervisor" && user?.scheduleaccess) ? (
          <>
            {/* <div className="mt-12">
              <p className="text-white text-[22px] PoppinsRegular ">Projects</p>
            </div> */}

            <div className=" mt-5 bg-cardOverlay rounded-xl drop-shadow-lg  py-[10px] bg-themelightblack">
              {/* --- DESKTOP TABLE VIEW (Visible on medium screens and up) --- */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full table-fixed divide-y divide-white/20 bg-themelightblack text-sm">
                  <thead className="ltr:text-left rtl:text-right">
                    <tr>
                      <th className="py-2 px-3 PoppinsRegular text-white w-[60px] text-center"></th>
                      <th className="py-2 px-3 PoppinsRegular text-white w-[22%] text-left">
                        Project
                      </th>
                      <th className="py-2 px-3 PoppinsRegular text-white w-[10%] text-center">
                        Supervisors
                      </th>
                      <th className="py-2 px-3 PoppinsRegular text-white w-[10%] text-center">
                        Employees
                      </th>
                      <th className="py-2 px-3 PoppinsRegular text-white w-[22%] text-center">
                        Email
                      </th>
                      <th className="py-2 px-3 PoppinsRegular text-white text-left pl-4">
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody className="">
                    {clients &&
                      clients.map((item, index) => (
                        <tr
                          key={index.toString()}
                          className="hover:bg-[#0989B826]/10 cursor-pointer"
                          onClick={() => {}}
                        >
                          <td className="py-2 px-3 whitespace-nowrap text-center">
                            <div className="flex justify-center items-center">
                              <img
                                loading="lazy"
                                src={item.logo != "" ? item.logo : userlogo}
                                className="w-[30px] h-[30px] lg:w-[40px] lg:h-[40px] rounded-lg object-cover"
                              />
                            </div>
                          </td>

                          <td className="py-2 px-3 whitespace-nowrap PoppinsRegular text-white text-left truncate">
                            {item.title}
                          </td>

                          <td className="py-2 px-3 whitespace-nowrap PoppinsRegular text-white text-center">
                            {
                              employees?.filter(function (data) {
                                return (
                                  data.projectassigned?.find(
                                    (project) => project.project === item?.id,
                                  ) != undefined &&
                                  data.usertype == "Supervisor"
                                );
                              })?.length
                            }
                          </td>

                          <td className="py-2 px-3 whitespace-nowrap PoppinsRegular text-white text-center">
                            {
                              employees?.filter(function (data) {
                                return (
                                  data.projectassigned?.find(
                                    (project) => project.project === item?.id,
                                  ) != undefined && data.usertype == "Employee"
                                );
                              })?.length
                            }
                          </td>

                          <td className="py-2 px-3 whitespace-nowrap PoppinsRegular text-white text-center truncate">
                            {item.email}
                          </td>

                          <td className="py-2 px-3 whitespace-nowrap text-left pl-4">
                            <div className="flex items-center justify-end gap-1.5 flex-wrap">
                              {user?.usertype == "SuperAdmin" ||
                              user?.usertype == "Admin" ||
                              (user?.usertype == "Supervisor" &&
                                user?.scheduleaccess) ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/CreateEmployeeSchedule", {
                                      state: { projectid: item.id },
                                    });
                                  }}
                                  type="submit"
                                  className="text-center px-2 py-1 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase"
                                >
                                  Schedule
                                </button>
                              ) : null}

                              {user?.usertype == "SuperAdmin" ||
                              user?.usertype == "Admin" ||
                              (user?.usertype == "Supervisor" &&
                                user?.scheduleaccess) ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/ProjectDesignations", {
                                      state: { projectid: item.id },
                                    });
                                  }}
                                  type="submit"
                                  className="text-center px-2 py-1 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase"
                                >
                                  Designations
                                </button>
                              ) : null}

                              {user?.usertype == "SuperAdmin" ||
                              user?.usertype == "Admin" ||
                              (user?.usertype == "Supervisor" &&
                                user?.editaccess) ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let newdata = [...item?.cleaningtasks];
                                    for (const key in newdata) {
                                      if (
                                        newdata[key].numberoftasks == undefined
                                      ) {
                                        newdata[key]["numberoftasks"] =
                                          newdata[key].tasksdata.length;

                                        for (const innerkey in newdata[key]
                                          .tasksdata) {
                                          newdata[key].tasksdata[innerkey][
                                            "id"
                                          ] = innerkey;
                                        }
                                      }
                                    }

                                    let itemnewdata = { ...item };
                                    itemnewdata.cleaningtasks = newdata;

                                    navigate("/EditProject", {
                                      state: { project: itemnewdata },
                                    });
                                  }}
                                  type="submit"
                                  className="text-center px-2 py-1 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase"
                                >
                                  Edit
                                </button>
                              ) : null}

                              {user?.usertype == "SuperAdmin" ||
                              user?.usertype == "Admin" ||
                              user?.usertype == "Supervisor" ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/ProjectEmployees", {
                                      state: { projectid: item.id },
                                    });
                                  }}
                                  type="submit"
                                  className="text-center px-2 py-1 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase"
                                >
                                  Employees
                                </button>
                              ) : null}

                              {user?.usertype == "SuperAdmin" ||
                              user?.usertype == "Admin" ||
                              (user?.usertype == "Supervisor" &&
                                user?.editaccess) ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/CreateEmployeeSchedule", {
                                      state: {
                                        projectid: item.id,
                                        openshift: true,
                                      },
                                    });
                                  }}
                                  type="submit"
                                  className="text-center px-2 py-1 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase"
                                >
                                  Open Shift
                                </button>
                              ) : null}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {/* --- MOBILE CARD VIEW (Visible only on small screens) --- */}
              <div className="block md:hidden divide-y divide-white/20 bg-themelightblack">
                {clients &&
                  clients.map((item, index) => (
                    <div key={index.toString()} className="p-4 space-y-3">
                      {/* Header Row: Logo & Left-Aligned Text Group */}
                      <div className="flex items-center gap-3">
                        <img
                          loading="lazy"
                          src={item.logo != "" ? item.logo : userlogo}
                          className="w-[40px] h-[40px] rounded-lg object-cover flex-shrink-0"
                        />
                        <div className="flex flex-col text-left min-w-0 flex-1">
                          <span className="PoppinsRegular text-white font-medium text-base truncate">
                            {item.title}
                          </span>
                          <span className="PoppinsRegular text-white/70 text-xs truncate">
                            {item.email}
                          </span>
                        </div>
                      </div>

                      {/* Metrics Row: Supervisors & Employees Counts */}
                      <div className="flex justify-around bg-white/5 py-2 rounded-lg border border-white/10 text-xs text-white PoppinsRegular">
                        <div>
                          <span className="text-white/60">Supervisors: </span>
                          <span className="font-semibold">
                            {
                              employees?.filter(function (data) {
                                return (
                                  data.projectassigned?.find(
                                    (project) => project.project === item?.id,
                                  ) != undefined &&
                                  data.usertype == "Supervisor"
                                );
                              })?.length
                            }
                          </span>
                        </div>
                        <div>
                          <span className="text-white/60">Employees: </span>
                          <span className="font-semibold">
                            {
                              employees?.filter(function (data) {
                                return (
                                  data.projectassigned?.find(
                                    (project) => project.project === item?.id,
                                  ) != undefined && data.usertype == "Employee"
                                );
                              })?.length
                            }
                          </span>
                        </div>
                      </div>

                      {/* Action Buttons Grid for Mobile */}
                      <div className="flex flex-wrap gap-2 pt-1 justify-start">
                        {user?.usertype == "SuperAdmin" ||
                        user?.usertype == "Admin" ||
                        (user?.usertype == "Supervisor" &&
                          user?.scheduleaccess) ? (
                          <button
                            onClick={() => {
                              navigate("/CreateEmployeeSchedule", {
                                state: { projectid: item.id },
                              });
                            }}
                            type="submit"
                            className="flex-1 min-w-[30%] py-1.5 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase text-center"
                          >
                            Schedule
                          </button>
                        ) : null}

                        {user?.usertype == "SuperAdmin" ||
                        user?.usertype == "Admin" ||
                        (user?.usertype == "Supervisor" &&
                          user?.scheduleaccess) ? (
                          <button
                            onClick={() => {
                              navigate("/ProjectDesignations", {
                                state: { projectid: item.id },
                              });
                            }}
                            type="submit"
                            className="flex-1 min-w-[30%] py-1.5 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase text-center"
                          >
                            Designations
                          </button>
                        ) : null}

                        {user?.usertype == "SuperAdmin" ||
                        user?.usertype == "Admin" ||
                        (user?.usertype == "Supervisor" && user?.editaccess) ? (
                          <button
                            onClick={() => {
                              let newdata = [...item?.cleaningtasks];
                              for (const key in newdata) {
                                if (newdata[key].numberoftasks == undefined) {
                                  newdata[key]["numberoftasks"] =
                                    newdata[key].tasksdata.length;

                                  for (const innerkey in newdata[key]
                                    .tasksdata) {
                                    newdata[key].tasksdata[innerkey]["id"] =
                                      innerkey;
                                  }
                                }
                              }

                              let itemnewdata = { ...item };
                              itemnewdata.cleaningtasks = newdata;

                              navigate("/EditProject", {
                                state: { project: itemnewdata },
                              });
                            }}
                            type="submit"
                            className="flex-1 min-w-[20%] py-1.5 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase text-center"
                          >
                            Edit
                          </button>
                        ) : null}

                        {user?.usertype == "SuperAdmin" ||
                        user?.usertype == "Admin" ||
                        user?.usertype == "Supervisor" ? (
                          <button
                            onClick={() => {
                              navigate("/ProjectEmployees", {
                                state: { projectid: item.id },
                              });
                            }}
                            type="submit"
                            className="flex-1 min-w-[45%] py-1.5 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase text-center"
                          >
                            Employees
                          </button>
                        ) : null}

                        {user?.usertype == "SuperAdmin" ||
                        user?.usertype == "Admin" ||
                        (user?.usertype == "Supervisor" && user?.editaccess) ? (
                          <button
                            onClick={() => {
                              navigate("/CreateEmployeeSchedule", {
                                state: { projectid: item.id, openshift: true },
                              });
                            }}
                            type="submit"
                            className="flex-1 min-w-[45%] py-1.5 rounded-md bg-themeblue text-white text-xs PoppinsRegular uppercase text-center"
                          >
                            Open Shift
                          </button>
                        ) : null}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </>
        ) : null}
        {user?.usertype == "AAdmin" && (
          <>
            <div className="mt-12">
              <h1 className="text-[22px] text-white PoppinsRegular ">
                Employees
              </h1>
            </div>
            <div className="overflow-x-auto mt-5  border border-white/20 backdrop-blur-lg my-12 bg-cardOverlay rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%]">
              <table className="min-w-full divide-y-2 divide-themegray bg-white text-sm ">
                <thead className="ltr:text-left rtl:text-right">
                  <tr>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white"></th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Name
                    </th>
                    {/* <th className="whitespace-nowrap py-2  PoppinsRegular text-white">Designation</th> */}
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Email
                    </th>
                    <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                      Phone Number
                    </th>

                    {/* <th className="whitespace-nowrap py-2  PoppinsRegular text-white pr-[15px]">Time Slot</th> */}
                  </tr>
                </thead>

                <tbody className="divide-y divide-themegray text-center">
                  {employees &&
                    employees.map((item, index) => {
                      let data = [...designationcolors];
                      if (
                        data?.find(
                          (data) => data.designation == item.designation,
                        ) == undefined
                      ) {
                        let object = {
                          designation: item.designation,
                          color: getRandomColor(),
                        };
                        data.push(object);
                        setdesignationcolors(data);
                      }

                      let colorcode = data.find(
                        (itemdata) => itemdata.designation == item.designation,
                      );

                      return (
                        !item?.disabled && (
                          <tr
                            key={index.toString()}
                            className="hover:bg-[#0989B826]/10 cursor-pointer"
                            // onClick={()=>{

                            // navigate('/dashboard', {state: {
                            //   employeedata: item
                            // }});
                            // }}
                          >
                            <td className="whitespace-nowrap px-4 py-2 flex justify-center  PoppinsRegular text-white">
                              <img
                                loading="lazy"
                                src={
                                  item.profilepicture != ""
                                    ? item.profilepicture
                                    : userlogo
                                }
                                className="w-[30px] h-[30px] lg:w-[40px] lg:h-[40px] rounded-full"
                              />
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
                              {item.firstname} {item.lastname}
                            </td>
                            {/* <td

                      className={`whitespace-nowrap px-4 py-2 `}>

                      <text
                        style={{ color: colorcode.color, backgroundColor: hexToRgba(colorcode.color, 0.3), }}
                        className={` PoppinsRegular  rounded-full px-[10px] py-[5px]`}
                      >{item.designation}</text>
                    </td> */}
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
                              {item.email}
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
                              {item?.phonenumber}
                            </td>

                            {/* <td className=' pr-[15px]'>
                        {item?.projectassigned ?
                        <>
                      {item?.starttime && item?.endtime ?
                        <text className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">{`${item.starttime} - ${item.endtime}`}</text>
                    :
                      <button
                      onClick={() =>{
                        navigate('/CreateEmployeeSchedule', {state: {
                          projectid: item.projectassigned,
                          employeedata: item
                        }});
                      }}
                      type='submit' className="text-center w-full py-[5px] rounded-md bg-themeColor text-white text-sm PoppinsRegular uppercase  ">Assign</button>
}
</>
:  <text className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white"></text>}
</td> */}
                          </tr>
                        )
                      );
                    })}
                </tbody>
              </table>
            </div>
          </>
        )}

        {user?.usertype == "Admin" ||
        (user?.usertype == "Supervisor" && user?.reportaccess) ? (
          <>
            <div className="mt-12 flex w-full justify-between items-center">
              <div>
                <p className="text-white text-[22px] PoppinsRegular ">
                  General Slots
                </p>
                <div className="flex flex-row items-center">
                  <button
                    onClick={() => {
                      setgroupby("Slot");
                    }}
                    type="submit"
                    className={`text-center px-[10px] py-[5px] rounded-md ${
                      groupby == "Slot"
                        ? "bg-themeblue text-white"
                        : "  text-white"
                    } text-sm PoppinsRegular uppercase   drop-shadow-lg`}
                  >
                    Individual
                  </button>
                  <button
                    onClick={() => {
                      setgroupby("Project");
                    }}
                    type="submit"
                    className={`ml-[5px] text-center px-[10px] py-[5px] rounded-md ${
                      groupby == "Project"
                        ? " bg-themeblue text-white"
                        : "  text-white"
                    } text-sm PoppinsRegular uppercase    drop-shadow-lg`}
                  >
                    Grouped
                  </button>
                </div>
              </div>
              {(generalemployeecheckindata?.length > 0 ||
                generalgroupedemployeecheckindata?.length > 0) && (
                <div className="flex flex-row">
                  {!user?.clientrole && (
                    <button
                      onClick={() => {
                        if (groupby == "Project") {
                          handleGroupedDownloadExcelGeneral();
                        } else {
                          handleDownloadExcelGeneral();
                        }
                      }}
                      type="submit"
                      className="text-center px-[10px] py-[5px] rounded-md bg-themeblue text-white text-sm PoppinsRegular uppercase  "
                    >
                      Export
                    </button>
                  )}

                  {user?.usertype == "Admin" && groupby != "Project" && (
                    <>
                      {recorddeletionloader ? (
                        <div className=" ml-[15px] py-2  w-full   flex items-center justify-center ">
                          <RotatingLines
                            visible={true}
                            height="25"
                            width="25"
                            strokeColor="#00C763"
                            strokeWidth="5"
                            animationDuration="0.75"
                            ariaLabel="rotating-lines-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                          />
                        </div>
                      ) : (
                        <button
                          onClick={() => {
                            setconfirmdeletepopup(true);
                            setdeletionmessage(
                              `Are you sure you want to delete shifts between ${moment(
                                startdate,
                              ).format("DD-MM-YYYY")} - ${moment(
                                enddate,
                              ).format("DD-MM-YYYY")} ?`,
                            );
                          }}
                          type="submit"
                          className="ml-[10px] text-center px-[10px] py-[5px] rounded-md bg-red-500 text-white text-sm PoppinsRegular uppercase  "
                        >
                          Delete All
                        </button>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
            <div className="   mb-20   my-5 py-[10px] ">
              <div className=" ">
                {/* <div className='w-[95%] mx-auto mt-5 lg:mt-10'>
<div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:gap-8">

<div className="flex flex-col items-center justify-center rounded-lg bg-themegray p-4 lg:p-8  bg-cardOverlay  drop-shadow-lg">
<p className="text-base text-white PoppinsRegular  md:text-lg">Today's Work</p>
<div className="text-sm  text-white/50 PoppinsRegular">{todayshours + " hrs"}</div>
</div>

<div className="flex flex-col items-center justify-center rounded-lg bg-themegray p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
<div className="text-base text-white PoppinsRegular  md:text-lg">Weeks's Work</div>
<div className="text-sm  text-white/50 PoppinsRegular">{weeklyhours + " hrs"}</div>
</div>


<div className="flex flex-col items-center justify-center rounded-lg bg-themegray p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
<div className="text-base text-white PoppinsRegular  md:text-lg">Months's Work</div>
<div className="text-sm  text-white/50 PoppinsRegular">{monthlyhours + " hrs"}</div>
</div>

<div className="flex flex-col items-center justify-center rounded-lg bg-themegray p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
<div className="text-base text-white PoppinsRegular  md:text-lg">Total Work Time</div>
<div className="text-sm  text-white/50 PoppinsRegular">{alltimehours + " hrs"}</div>
</div>

</div>
</div> */}
                {/* <div className='flex w-full items-center justify-center my-12'>
<div className='flex flex-col items-center'>
<img src={employeedata?.profilepicture} className='w-[130px] h-[130px] rounded-full object-cover  bg-cardOverlay  drop-shadow-lg' />
<div className='flex flex-col text-center pt-2'>
<text className='text-white PoppinsRegular font-bold text-xl'>{employeedata?.firstname + " " + employeedata?.lastname}</text>
<text className='text-white/60 PoppinsRegular  text-sm'>{employeedata?.designation}</text>
</div>
</div>
</div> */}

                <div className=" mx-auto flex flex-row flex-wrap justify-between items-center">
                  <div className="w-full lg:w-[24%]">
                    <div className="flex flex-row items-end justify-between pb-1 relative">
                      <p className="PoppinsRegular  text-white text-sm ">
                        Select Project
                      </p>
                      {project != "" && (
                        <p
                          onClick={() => {
                            dispatch({
                              type: actionType.SELECTPROJECT,
                              payload: "",
                            });
                            dispatch({
                              type: actionType.SELECTDESIGNATION,
                              payload: [],
                            });
                          }}
                          className="ml-[5px] text-[13px] text-red-600 cursor-pointer hover:underline"
                        >
                          Clear
                        </p>
                      )}
                      <ProjectPopUp
                        style={{ top: "70px", left: "0px" }}
                        visible={projectselectionpopup}
                        data={clients}
                        activateoutsidecontainerclick={() => {
                          setprojectselectionpopup(false);
                        }}
                        onClickcorrect={(item) => {
                          dispatch({
                            type: actionType.SELECTPROJECT,
                            payload: item,
                          });
                          let data = { ...item };
                          if (data?.designation?.length > 0) {
                            for (const key in data.designation) {
                              data.designation[key]["selected"] = false;
                            }
                          }
                          dispatch({
                            type: actionType.SELECTDESIGNATION,
                            payload: data.designation,
                          });

                          setprojectselectionpopup(false);
                        }}
                      />
                    </div>
                    <div
                      onClick={() =>
                        setprojectselectionpopup(!projectselectionpopup)
                      }
                      className="bg-cardOverlay  drop-shadow-lg  px-4 text-white text-sm  PoppinsRegular w-full py-[10px] rounded-xl   bg-themelightblack  items-center flex"
                    >
                      {project == "" ? "Select Project" : project.title}
                    </div>
                  </div>
                  {project != "" && designation?.length > 0 && (
                    <div className="w-full lg:w-[24%]">
                      <div className="flex flex-row items-end justify-between pb-1 mt-4 lg:mt-0  ">
                        <p className="PoppinsRegular  text-white text-sm ">
                          Designation
                        </p>
                        {designation?.length > 0 && (
                          <p
                            onClick={() => {
                              dispatch({
                                type: actionType.SELECTDESIGNATION,
                                payload: [],
                              });
                            }}
                            className="ml-[5px] text-[13px] text-red-600 cursor-pointer hover:underline"
                          >
                            Clear
                          </p>
                        )}
                      </div>
                      <div className="w-full relative">
                        <div
                          onClick={() =>
                            setdesignationselectionpopup(
                              !designationselectionpopup,
                            )
                          }
                          className="bg-cardOverlay  drop-shadow-lg  px-4 text-white text-sm  PoppinsRegular w-full py-[10px] rounded-xl  bg-themelightblack  items-center flex flex-wrap"
                        >
                          {designation?.length == 0 ||
                          designation.find((data) => data.selected == true) ==
                            undefined
                            ? "Select Designation"
                            : designation
                                .filter(function (data) {
                                  return data.selected == true;
                                })
                                .map(function (data) {
                                  return (
                                    <div
                                      onClick={() => {
                                        let dataset = [...designation];
                                        const designationindex =
                                          dataset.findIndex(
                                            (item) =>
                                              item.designation ===
                                              data.designation,
                                          );
                                        dataset[designationindex].selected =
                                          false;
                                        dispatch({
                                          type: actionType.SELECTDESIGNATION,
                                          payload: dataset,
                                        });
                                      }}
                                      className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                                    >
                                      <text className="text-white ">
                                        {data.designation}
                                      </text>
                                      <IoIosCloseCircle className=" text-red-500 ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer" />
                                    </div>
                                  );
                                })}
                        </div>

                        <DesignationPopUp
                          bulkaction={(status) => {
                            let data = [...designation];
                            const updatedArray = data.map((item) => ({
                              ...item,
                              selected: status,
                            }));

                            dispatch({
                              type: actionType.SELECTDESIGNATION,
                              payload: updatedArray,
                            });
                          }}
                          multi={true}
                          visible={designationselectionpopup}
                          data={designation}
                          activateoutsidecontainerclick={() => {
                            setdesignationselectionpopup(false);
                          }}
                          onClick={(item, index) => {
                            let data = [...designation];
                            data[index].selected = !data[index].selected;
                            //         data.designation[index].selected = !data.designation[index].selected
                            // setproject(data)
                            dispatch({
                              type: actionType.SELECTDESIGNATION,
                              payload: data,
                            });
                          }}
                        />
                      </div>
                    </div>
                  )}
                  <div className="w-full lg:w-[24%] mt-4 lg:mt-0">
                    <p className="PoppinsRegular  text-white text-sm pb-1">
                      From
                    </p>
                    <DatePicker
                      className="bg-cardOverlay  drop-shadow-lg  input PoppinsRegular   rounded-xl w-full border-none  bg-themelightblack   text-white"
                      selected={startdate}
                      onChange={(date) =>
                        dispatch({
                          type: actionType.STARTDATE,
                          payload: new Date(date.setHours(0, 0, 0, 0)),
                        })
                      }
                    />
                  </div>
                  <div className="w-full lg:w-[24%] mt-4 lg:mt-0">
                    <p className="PoppinsRegular  text-white text-sm pb-1">
                      To
                    </p>
                    <DatePicker
                      className="bg-cardOverlay  drop-shadow-lg  input PoppinsRegular   rounded-xl w-full bg-themelightblack border-none  text-white"
                      selected={enddate}
                      onChange={(date) =>
                        dispatch({
                          type: actionType.ENDDATE,
                          payload: new Date(date.setHours(23, 59, 59, 59)),
                        })
                      }
                    />
                  </div>
                </div>

                {groupby == "Project" ? (
                  <div className="mx-auto flex flex-row flex-wrap justify-between items-center ">
                    <div className="overflow-x-auto rounded-lg  my-5 w-full">
                      <table className="min-w-full max-w-full divide-y divide-white/20 bg-cardOverlay  drop-shadow-lg  bg-themelightblack  text-sm">
                        <thead className="ltr:text-left rtl:text-right">
                          <tr>
                            <th className="whitespace-nowrap py-2 PoppinsRegular text-white px-10"></th>
                            <th className="whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Project
                            </th>
                            <th className="whitespace-nowrap py-2 PoppinsRegular text-white px-10"></th>
                            <th className="whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Employee Name
                            </th>
                            <th className="whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Designation
                            </th>
                            <th className="whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Hours Worked
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-center w-full">
                          {loading ? (
                            <div className="py-10 w-full flex items-center justify-center absolute">
                              <RotatingLines
                                visible={true}
                                height="25"
                                width="25"
                                strokeColor="#00C763"
                                strokeWidth="5"
                                animationDuration="0.75"
                                ariaLabel="rotating-lines-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                            </div>
                          ) : (
                            generalgroupedemployeecheckindata.map(
                              (item, index) =>
                                designation.find(
                                  (data) => data.selected == true,
                                ) == undefined ||
                                designation.find(
                                  (data) =>
                                    data.selected == true &&
                                    item.projectdesignation == data.designation,
                                ) != undefined ? (
                                  <tr
                                    key={index.toString()}
                                    className="cursor-pointer hover:bg-[#0989B826]/10"
                                  >
                                    <td className="whitespace-nowrap px-4 py-2 PoppinsRegular text-white flex justify-center">
                                      <img
                                        loading="lazy"
                                        src={item.projectprofilepicture}
                                        className="w-[35px] h-[35px] object-cover rounded-full"
                                        alt="Project Profile"
                                      />
                                    </td>

                                    <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                      {item.projectname ? (
                                        <span className="text-white">
                                          {item.projectname}
                                        </span>
                                      ) : (
                                        <span className="text-white/40">
                                          Not Available
                                        </span>
                                      )}
                                    </td>

                                    <td className="whitespace-nowrap px-4 py-2 PoppinsRegular text-white flex justify-center">
                                      <img
                                        loading="lazy"
                                        src={item.profilepicture}
                                        className="w-[35px] h-[35px] object-cover rounded-full"
                                        alt="Employee Profile"
                                      />
                                    </td>

                                    <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                      {item.name ? (
                                        <span className="text-white">
                                          {item.name}
                                        </span>
                                      ) : (
                                        <span className="text-white/40">
                                          Not Available
                                        </span>
                                      )}
                                    </td>

                                    <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                      {item.projectdesignation ? (
                                        <span className="text-white">
                                          {item.projectdesignation}
                                        </span>
                                      ) : (
                                        <span className="text-white/40">
                                          Not Available
                                        </span>
                                      )}
                                    </td>

                                    <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                      {item?.minutes ? (
                                        <span className="text-white">
                                          {parseInt(item?.minutes / 60) +
                                            " hrs " +
                                            parseInt(item?.minutes % 60) +
                                            " mins"}
                                        </span>
                                      ) : (
                                        <span className="text-white/40">
                                          NA
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                ) : null,
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="mx-auto flex flex-row flex-wrap justify-between items-center">
                    <div className="overflow-x-auto rounded-lg bg-cardOverlay drop-shadow-lg my-5 w-full relative">
                      {/* Added table-fixed to lock column widths */}
                      <table className="table-fixed bg-cardOverlay drop-shadow-lg w-[1600px] divide-y divide-white/20 bg-themelightblack text-sm">
                        <thead className="ltr:text-left rtl:text-right">
                          <tr>
                            <th className="w-[50px] whitespace-nowrap py-2 PoppinsRegular text-white px-4"></th>
                            <th className="w-[50px] whitespace-nowrap py-2 PoppinsRegular text-white"></th>
                            <th className="w-[110px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Date
                            </th>
                            <th className="w-[80px] whitespace-nowrap py-2 PoppinsRegular text-white px-10"></th>
                            <th className="w-[150px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Employee Name
                            </th>
                            <th className="w-[130px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Designation
                            </th>
                            <th className="w-[110px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Checkin Time
                            </th>
                            <th className="w-[110px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Checkout Time
                            </th>
                            <th className="w-[120px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Hours Worked
                            </th>
                            <th className="w-[130px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Checkin Location
                            </th>
                            <th className="w-[130px] whitespace-nowrap py-2 PoppinsRegular text-white px-4">
                              Checkout Location
                            </th>
                            <th className="w-[220px] whitespace-nowrap py-2 PoppinsRegular text-white px-4 text-left">
                              Supervisor Note
                            </th>
                            <th className="w-[220px] whitespace-nowrap py-2 PoppinsRegular text-white px-4 text-left">
                              Employee Note
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-center w-full">
                          {loading ? (
                            <div className="py-10 w-full flex items-center justify-center absolute">
                              <RotatingLines
                                visible={true}
                                height="25"
                                width="25"
                                strokeColor="#00C763"
                                strokeWidth="5"
                                animationDuration="0.75"
                                ariaLabel="rotating-lines-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                            </div>
                          ) : (
                            generalemployeecheckindata.map((item, index) =>
                              designation.find(
                                (data) => data.selected == true,
                              ) == undefined ||
                              designation.find(
                                (data) =>
                                  data.selected == true &&
                                  item.projectdesignation == data.designation,
                              ) != undefined ? (
                                <tr
                                  key={index.toString()}
                                  className={`cursor-pointer ${
                                    item?.hoursapproved == false
                                      ? "bg-red-500/10"
                                      : "hover:bg-[#0989B826]/10"
                                  }`}
                                >
                                  {(user.usertype == "Supervisor" &&
                                    user?.deleteaccess == true) ||
                                  user.usertype == "Admin" ||
                                  user.usertype == "SuperAdmin" ? (
                                    item?.hoursapproved != true ? (
                                      <td className="w-[50px] whitespace-nowrap px-2 py-2 PoppinsRegular">
                                        <MdDelete
                                          onClick={() => {
                                            setconfirmdeletepopup(true);
                                            setdeletionmessage(
                                              "Are you sure you want to delete this shift?",
                                            );
                                            setdeletiondata(item);
                                          }}
                                          className="text-lighttextGray hover:text-red-500 w-[20px] h-[20px] hover:cursor-pointer"
                                        />
                                      </td>
                                    ) : (
                                      <td className="w-[50px]"></td>
                                    )
                                  ) : (
                                    <td className="w-[50px]"></td>
                                  )}

                                  {(user.usertype == "Supervisor" &&
                                    user?.editaccess == true) ||
                                  user.usertype == "Admin" ||
                                  user.usertype == "SuperAdmin" ? (
                                    item?.hoursapproved != false ? (
                                      <td className="w-[50px] whitespace-nowrap py-2 PoppinsRegular">
                                        <MdEditDocument
                                          onClick={() => {
                                            navigate("/UpdateSlot", {
                                              state: {
                                                edit: true,
                                                editdoc: item,
                                                projectid: item.projectid,
                                                employeedata:
                                                  item.employeedata[0],
                                                projectdesignation:
                                                  item.projectdesignation,
                                              },
                                            });
                                          }}
                                          className="text-lighttextGray hover:text-themegreen w-[17px] h-[17px] hover:cursor-pointer"
                                        />
                                      </td>
                                    ) : (
                                      <td className="w-[50px]"></td>
                                    )
                                  ) : (
                                    <td className="w-[50px]"></td>
                                  )}

                                  <td className="w-[110px] whitespace-nowrap px-4 py-2 PoppinsRegular text-white">
                                    {moment(item.checkindate).format(
                                      "DD-MM-YYYY",
                                    )}
                                  </td>

                                  <td className="w-[80px] whitespace-nowrap px-4 py-2 PoppinsRegular text-white align-middle">
                                    <div className="flex justify-center items-center h-full">
                                      <img
                                        loading="lazy"
                                        src={item.profilepicture}
                                        className="w-[35px] h-[35px] object-cover rounded-full"
                                        alt="Profile"
                                      />
                                    </div>
                                  </td>
                                  <td className="w-[150px] whitespace-nowrap px-4 py-2 PoppinsRegular text-white truncate">
                                    {item.name}
                                  </td>

                                  <td className="w-[130px] whitespace-nowrap px-4 py-2 PoppinsRegular text-white truncate">
                                    {item.projectdesignation}
                                  </td>

                                  <td className="w-[110px] whitespace-nowrap px-4 py-2 PoppinsRegular">
                                    {item.checkintime ? (
                                      <span className="text-white">
                                        {item.checkintime}
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>

                                  <td className="w-[110px] whitespace-nowrap px-4 py-2 PoppinsRegular">
                                    {item.checkouttime ? (
                                      <span className="text-white">
                                        {item.checkouttime}
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>

                                  <td className="w-[120px] whitespace-nowrap px-4 py-2 PoppinsRegular">
                                    {item?.minutes ? (
                                      <span className="text-themegreen">
                                        {parseInt(item?.minutes / 60) +
                                          " hrs " +
                                          parseInt(item?.minutes % 60) +
                                          " mins"}
                                      </span>
                                    ) : (
                                      <span className="text-white/40">NA</span>
                                    )}
                                  </td>

                                  <td
                                    className="w-[130px] whitespace-nowrap px-4 py-2 PoppinsRegular"
                                    onClick={() => {
                                      if (item?.checkinlatitude) {
                                        getlocationaddress(
                                          item?.checkinlatitude,
                                          item?.checkinlongitude,
                                        );
                                      }
                                    }}
                                  >
                                    {item?.checkinlatitude ? (
                                      <span className="text-white cursor-pointer hover:underline">
                                        View
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>

                                  <td
                                    className="w-[130px] whitespace-nowrap px-4 py-2 PoppinsRegular"
                                    onClick={() => {
                                      if (item?.checkoutlatitude) {
                                        getlocationaddress(
                                          item?.checkoutlatitude,
                                          item?.checkoutlongitude,
                                        );
                                      }
                                    }}
                                  >
                                    {item?.checkoutlatitude ? (
                                      <span className="text-white cursor-pointer hover:underline">
                                        View
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>

                                  {/* Supervisor Note */}
                                  <td className="w-[220px] max-w-[220px] px-4 py-2 PoppinsRegular text-left ">
                                    {item?.supervisornotes ? (
                                      <div
                                        onClick={(e) =>
                                          toggleExpand(e, index, "supervisor")
                                        }
                                        className={`text-white cursor-pointer break-words leading-snug select-none ${
                                          expandedNote.rowIndex === index &&
                                          expandedNote.type === "supervisor"
                                            ? "align-top"
                                            : "line-clamp-2 "
                                        }`}
                                        title="Click to toggle full note"
                                      >
                                        {item.supervisornotes}
                                      </div>
                                    ) : (
                                      <span className="text-white/40">
                                        None
                                      </span>
                                    )}
                                  </td>

                                  {/* Employee Note */}
                                  <td className="w-[220px] max-w-[220px] px-4 py-2 PoppinsRegular text-left ">
                                    {item?.employeenotes ? (
                                      <div
                                        onClick={(e) =>
                                          toggleExpand(e, index, "employee")
                                        }
                                        className={`text-white cursor-pointer break-words leading-snug select-none ${
                                          expandedNote.rowIndex === index &&
                                          expandedNote.type === "employee"
                                            ? "align-top"
                                            : "line-clamp-2 "
                                        }`}
                                        title="Click to toggle full note"
                                      >
                                        {item.employeenotes}
                                      </div>
                                    ) : (
                                      <span className="text-white/40">
                                        None
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ) : null,
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : null}

        <Confirmationpopup
          visible={confirmdeletepopup}
          picture={employeedata?.profilepicture}
          text={deletionmessage}
          accept={() => {
            if (
              deletionmessage == "Are you sure you want to delete this shift?"
            ) {
              deletesinglerecord();
            } else {
              handleDeleteGeneral();
            }

            setconfirmdeletepopup(false);
          }}
          cancel={() => {
            setconfirmdeletepopup(false);
          }}
        />
        {userpopup && (
          <div
            ref={userpopupref}
            className="bg-themeColor border border-bordercolor w-[200px] fixed z-50 right-[40px] top-[60px] rounded-xl flex flex-col items-center py-[20px] px-[15px]"
          >
            <img
              loading="lazy"
              src={
                user?.profilepicture
                  ? user?.profilepicture
                  : user?.logo
                    ? user?.logo
                    : userlogo
              }
              className="w-[45px] h-[45px] object-contain rounded-full"
            />
            <p className="text-white PoppinsRegular mt-[5px] text-base pt-1">
              {user.usertype == "Project"
                ? user?.name
                : user?.usertype == "Project"
                  ? user?.title
                  : user?.firstname + " " + user?.lastname}
            </p>
            <p className="text-lightgrey PoppinsRegular text-[12px]">
              {user?.usertype}
            </p>
            <div className="mt-[15px] w-[100%]">
              {user?.usertype != "Project" && (
                <div
                  className="pb-[5px] flex items-center w-[100%]"
                  onClick={() => {
                    editprofile();
                  }}
                >
                  <img
                    loading="lazy"
                    src={Signins}
                    className="w-[16px] h-[16px] object-contain"
                    alt="Signout"
                  />
                  <p className="PoppinsRegular text-white text-[12px] ml-[5px] cursor-pointer">
                    Settings
                  </p>
                </div>
              )}
              <div
                className="pb-[5px] flex items-center w-[100%]"
                onClick={() => {
                  requestPermission();
                }}
              >
                <img
                  loading="lazy"
                  src={Signins}
                  className="w-[16px] h-[16px] object-contain"
                  alt="Signout"
                />
                <p className=" PoppinsRegular text-white text-[12px] ml-[5px] cursor-pointer">
                  Log Out
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  const renderPopup = () => {
    switch (selectedtile) {
      case "Dashboard":
        return <Dashboard />;
      case "Slots":
        return <Slots />;
      case "Leave Request":
        return <LeaveRequest />;
      case "Create User":
        return <CreateEmployee />;
      case "Employees":
        return <HoursWorked />;
      case "Create Project":
        return <CreateProject />;
      case "Express Delivery":
        return <CreateExpressDelivery />;

      case "Vehicle":
        return <CreateVehichle />;
      case "To Do List":
        return <ToDolist />;
      case "Assign Project":
        return <AddEmployeeToProject />;
      case "Assign Vehicle":
        return <AddSupervisorToVehicle />;
      case "Blogs":
        return <Blogs />;

      default:
        return null;
    }
  };
  return (
    <div className="w-[100%] flex flex-row h-screen overflow-hidden bg-themeColor">
      {/* SideMenu Container: Pass the state handler down */}
      <div className="flex-shrink-0">
        <SideMenu
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setIsSidebarCollapsed}
        />
      </div>

      {/* Main Content Area: Automatically stretches (flex-1) and adjusts smoothly */}
      <div className="flex-1 h-screen overflow-y-auto px-[20px] py-[30px] flex justify-center transition-all duration-300">
        <div className="w-full max-w-7xl">{renderPopup()}</div>
      </div>
    </div>
  );
};

export default AdminHome;
